import React, { useEffect, useRef } from 'react';
import './SettingsPopup.css';
import gsap from 'gsap';
import rockBg from '../../asserts/rockbg.png';
import Btn3 from '../common/Btn3';
import './PopupShared.css';
import { useMusic } from './MusicContext';

const SettingsPopup = ({ onClose }) => {
  const scrollRef = useRef();
  const contentRef = useRef();
  const { music, setMusic, sfx, setSfx } = useMusic();
  const [notif, setNotif] = React.useState(true);

  useEffect(() => {
    gsap.set(scrollRef.current, {
      rotation: 60,
      rotationX: -40,
      opacity: 0,
      transformOrigin: 'center center',
      transformPerspective: 1400,
      x: 100,
      y: 820,
      scale: 0.8,
    });

    const tl = gsap.timeline();
    tl.to(scrollRef.current, {
      rotation: 0,
      rotationX: 0,
      opacity: 1,
      x: 0,
      y: 0,
      scale: 1,
      duration: 1.3,
      ease: 'power3.out',
    }).fromTo(
      contentRef.current.querySelectorAll('.popup-animate'),
      { opacity: 0, y: 30 },
      { opacity: 1, y: 0, duration: 0.6, stagger: 0.12, ease: 'power2.out' },
      '-=0.4'
    );
  }, []);

  const handleClose = () => {
    const tl = gsap.timeline({ onComplete: onClose });
    tl.to(contentRef.current.querySelectorAll('.popup-animate'), {
      opacity: 0,
      y: 20,
      duration: 0.25,
      stagger: 0.06,
      ease: 'power2.in',
    }).to(scrollRef.current, {
      rotation: -20,
      rotationX: 40,
      opacity: 0,
      x: -200,
      y: 120,
      scale: 0.8,
      duration: 1,
      ease: 'power3.in',
    }, '-=0.1');
  };

  return (
    <div className="popup-overlay">
      <div className="popup-scroll" ref={scrollRef} style={{ backgroundImage: `url(${rockBg})` }}>
        <div className="popup-inner" ref={contentRef}>
          <h2 className="popup-title popup-animate">Settings</h2>
          <div className="settings-toggles popup-animate">
            <div className="settings-toggle-item">
              <button className={`settings-icon-btn ${!music ? 'off' : ''}`} onClick={() => setMusic(!music)}>
                <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M10 18H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h4l10 8V10L10 18Z" fill="#EFCB7D"/>
                  <path d="M32 16c3.3 2.7 5 6.1 5 8s-1.7 5.3-5 8" stroke="#EFCB7D" strokeWidth="3" strokeLinecap="round"/>
                  <path d="M37 11c5 4 8 8.5 8 13s-3 9-8 13" stroke="#EFCB7D" strokeWidth="3" strokeLinecap="round"/>
                  {!music && <line x1="4" y1="4" x2="44" y2="44" stroke="#7a5c38" strokeWidth="4" strokeLinecap="round"/>}
                </svg>
              </button>
              <span className="settings-label">Music</span>
            </div>
            <div className="settings-toggle-item">
              <button className={`settings-icon-btn ${!sfx ? 'off' : ''}`} onClick={() => setSfx(!sfx)}>
                <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <polygon points="8,16 8,32 20,32 34,44 34,4 20,16" fill="#EFCB7D"/>
                  <path d="M38 18c2.5 2 4 4.5 4 6s-1.5 4-4 6" stroke="#EFCB7D" strokeWidth="3" strokeLinecap="round"/>
                  {!sfx && <line x1="4" y1="4" x2="44" y2="44" stroke="#7a5c38" strokeWidth="4" strokeLinecap="round"/>}
                </svg>
              </button>
              <span className="settings-label">SFX</span>
            </div>
            <div className="settings-toggle-item">
              <button className={`settings-icon-btn ${!notif ? 'off' : ''}`} onClick={() => setNotif(!notif)}>
                <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M24 4a4 4 0 0 0-4 4v2.2C14.3 11.8 10 17 10 23v9l-3 4h34l-3-4v-9c0-6-4.3-11.2-10-12.8V8a4 4 0 0 0-4-4Z" fill="#EFCB7D"/>
                  <path d="M20 36a4 4 0 0 0 8 0" fill="#EFCB7D"/>
                  {!notif && <line x1="4" y1="4" x2="44" y2="44" stroke="#7a5c38" strokeWidth="4" strokeLinecap="round"/>}
                </svg>
              </button>
              <span className="settings-label">Notifications</span>
            </div>
          </div>
          <a className="tutorial-link popup-animate" href="https://youtu.be/Wekof1ZdL28" target="_blank" rel="noreferrer">
            <button className="tutorial-btn">Tutorial</button>
          </a>
          <div className="popup-back popup-animate">
            <Btn3 onClick={handleClose} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SettingsPopup;